var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 154,
    viewBox: "0 0 126 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_6387_16936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 44.3333C13 31.8718 13 25.641 15.6795 21C17.4349 17.9596 19.9596 15.4349 23 13.6795C27.641 11 33.8718 11 46.3333 11C71.2564 11 83.718 11 93 16.359C99.0808 19.8697 104.13 24.9192 107.641 31C113 40.282 113 52.7436 113 77.6667C113 90.1282 113 96.359 110.321 101C108.565 104.04 106.04 106.565 103 108.321C98.359 111 92.1282 111 79.6667 111H50.6C34.0664 111 25.7996 111 20.2515 106.41C19.2825 105.609 18.3913 104.717 17.5897 103.748C13 98.2004 13 89.9336 13 73.4V44.3333Z",
    fill: "url(#paint0_linear_6387_16936)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6387_16936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.7567 48.84V81.6555C83.7567 84.9423 81.0919 87.6071 77.8051 87.6071H48.1547C44.8679 87.6071 42.2031 84.9423 42.2031 81.6555V40.3451C42.2031 37.0583 44.8679 34.3936 48.1547 34.3936H70.0002V44.2544C70.0002 46.7974 72.0561 48.8533 74.5991 48.8533H83.7567V48.84Z",
    fill: "#B5FF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 34.3936L83.7565 48.8537H74.5989C72.0559 48.8537 70 46.7974 70 44.2544V34.3936Z",
    fill: "#B5FF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9745 33.4328C70.7178 33.1624 70.3661 33 70.0009 33H48.1553C44.1243 33 40.7969 36.3141 40.7969 40.3448V81.6552C40.7969 85.6859 44.1243 89 48.1553 89H77.8058C81.8364 89 85.1638 85.6859 85.1638 81.6552V48.8397C85.1638 48.4881 85.0015 48.1497 84.7716 47.8929L70.9745 33.4328ZM71.3672 37.7749L80.6055 47.4734H74.5997C72.8143 47.4734 71.3672 46.0396 71.3672 44.2404V37.7749ZM77.8058 86.2947H48.1553C45.626 86.2947 43.5022 84.1982 43.5022 81.6552V40.3448C43.5022 37.8155 45.6124 35.7053 48.1553 35.7053H68.6619V44.2404C68.6619 47.5276 71.3129 50.1787 74.5997 50.1787H82.4589V81.6552C82.4589 84.1982 80.3488 86.2947 77.8058 86.2947Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1095 76.9619H51.8448C51.101 76.9619 50.4922 77.5703 50.4922 78.3146C50.4922 79.0584 51.101 79.6672 51.8448 79.6672H74.1232C74.867 79.6672 75.4758 79.0584 75.4758 78.3146C75.4758 77.5703 74.867 76.9619 74.1095 76.9619Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9946 72.1052C62.2518 72.3756 62.6035 72.538 62.982 72.538C63.361 72.538 63.7126 72.3756 63.9694 72.1052L71.8824 63.597C72.3968 63.0557 72.3562 62.1901 71.8149 61.6898C71.274 61.1758 70.408 61.2164 69.9077 61.7573L64.3347 67.7498V52.9786C64.3347 52.2348 63.7263 51.626 62.982 51.626C62.2382 51.626 61.6293 52.2344 61.6293 52.9786V67.7494L56.0563 61.7573C55.5424 61.2164 54.6904 61.1758 54.1491 61.6898C53.6082 62.2037 53.5676 63.0557 54.0816 63.5966L61.9946 72.1052Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.3805 20.25C12.8869 22.8369 12.1854 25.799 11.8411 29.5986C11.5 33.3618 11.5 38.0906 11.5 44.2559V44.3333V73.4V73.5036C11.5 81.6828 11.5 87.9556 12.0842 92.8709C12.6749 97.8404 13.8807 101.618 16.434 104.705C17.2957 105.746 18.2537 106.704 19.2954 107.566C22.3817 110.119 26.1596 111.325 31.1291 111.916C36.0444 112.5 42.3173 112.5 50.4965 112.5H50.6H79.6667H79.7439C85.9093 112.5 90.6382 112.5 94.4014 112.159C98.201 111.815 101.163 111.113 103.75 109.62C107.018 107.733 109.733 105.018 111.62 101.75C113.113 99.1631 113.815 96.201 114.159 92.4014C114.5 88.6382 114.5 83.9093 114.5 77.744V77.6667V77.588C114.5 65.193 114.5 55.7912 113.824 48.3325C113.145 40.8375 111.773 35.1574 108.94 30.25C105.298 23.9412 100.059 18.7023 93.75 15.0599C88.8426 12.2267 83.1625 10.8553 75.6675 10.176C68.2088 9.49999 58.8071 9.5 46.4121 9.5H46.3333H46.2559C40.0906 9.49999 35.3618 9.49999 31.5986 9.84106C27.799 10.1854 24.8369 10.8869 22.25 12.3805C18.9816 14.2675 16.2675 16.9816 14.3805 20.25Z",
    stroke: "#E8E8DB",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0453 148H18.5053V133.64H23.0453C27.6253 133.64 30.2653 136.56 30.2653 140.76C30.2653 144.9 27.5253 148 23.0453 148ZM20.7053 135.54V146.1H22.9453C26.2453 146.1 28.0253 144.06 28.0253 140.76C28.0253 137.52 26.2653 135.54 22.9453 135.54H20.7053ZM36.8478 148.2C33.8478 148.2 31.6478 145.84 31.6478 142.7C31.6478 139.56 33.8478 137.2 36.8478 137.2C39.8478 137.2 42.0478 139.56 42.0478 142.7C42.0478 145.84 39.8478 148.2 36.8478 148.2ZM36.8478 146.42C38.5878 146.42 39.9678 145.02 39.9678 142.7C39.9678 140.38 38.5878 139 36.8478 139C35.1078 139 33.7478 140.38 33.7478 142.7C33.7478 145.02 35.1078 146.42 36.8478 146.42ZM52.6327 148L50.2327 140.12L47.8127 148H45.7727L42.7127 137.4H44.6927L46.8327 145.12L49.2327 137.4H51.2327L53.5927 145.14L55.7327 137.4H57.7327L54.6527 148H52.6327ZM61.4005 142.02V148H59.3805V137.4H61.2605V139.16C61.9805 137.98 63.1805 137.2 64.6405 137.2C66.8205 137.2 68.2605 138.6 68.2605 141.14V148H66.2405V141.82C66.2405 140 65.4405 138.98 63.9405 138.98C62.5605 138.98 61.4005 140.14 61.4005 142.02ZM72.983 148H70.943V133.64H72.983V148ZM80.2267 148.2C77.2267 148.2 75.0267 145.84 75.0267 142.7C75.0267 139.56 77.2267 137.2 80.2267 137.2C83.2267 137.2 85.4267 139.56 85.4267 142.7C85.4267 145.84 83.2267 148.2 80.2267 148.2ZM80.2267 146.42C81.9667 146.42 83.3467 145.02 83.3467 142.7C83.3467 140.38 81.9667 139 80.2267 139C78.4867 139 77.1267 140.38 77.1267 142.7C77.1267 145.02 78.4867 146.42 80.2267 146.42ZM93.9059 148V146.36C93.2459 147.54 92.0659 148.2 90.5059 148.2C88.3059 148.2 86.8659 146.94 86.8659 145C86.8659 142.92 88.5259 141.84 91.6859 141.84C92.3059 141.84 92.8059 141.86 93.6659 141.96V141.18C93.6659 139.66 92.8459 138.8 91.4459 138.8C89.9659 138.8 89.0659 139.68 89.0059 141.16H87.1659C87.2659 138.78 88.9659 137.2 91.4459 137.2C94.0659 137.2 95.5859 138.68 95.5859 141.2V148H93.9059ZM88.7859 144.94C88.7859 146.04 89.6059 146.76 90.9059 146.76C92.6059 146.76 93.6659 145.7 93.6659 144.08V143.22C92.8859 143.12 92.3259 143.1 91.8059 143.1C89.7859 143.1 88.7859 143.7 88.7859 144.94ZM97.5267 142.7C97.5267 139.48 99.3667 137.2 102.227 137.2C103.647 137.2 104.887 137.92 105.627 139.22V133.64H107.647V148H105.767V146.1C105.007 147.44 103.727 148.2 102.227 148.2C99.3667 148.2 97.5267 145.88 97.5267 142.7ZM99.6267 142.7C99.6267 145.06 100.867 146.4 102.627 146.4C104.347 146.4 105.627 145 105.627 142.66C105.627 140.28 104.307 138.98 102.627 138.98C100.867 138.98 99.6267 140.3 99.6267 142.7Z",
    fill: "#E8E8DB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_6387_16936",
    x: 0,
    y: 0,
    width: 126,
    height: 126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.647059 0 0 0 0 0.941176 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6387_16936"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.909804 0 0 0 0 0.858824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_6387_16936",
    result: "effect2_dropShadow_6387_16936"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_6387_16936",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6387_16936",
    x1: 75.8514,
    y1: 226.625,
    x2: 32.2602,
    y2: -2.68014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6387_16936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(35 33)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadNew);
export default __webpack_public_path__ + "static/media/download-new.26d33a1e658d47ae40993e98e47c9342.svg";
export { ForwardRef as ReactComponent };